import { render, staticRenderFns } from "./RemarkControl.vue?vue&type=template&id=0870d331&scoped=true&"
import script from "./RemarkControl.vue?vue&type=script&lang=js&"
export * from "./RemarkControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870d331",
  null
  
)

export default component.exports